import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    console.log("Nested form controller connected")
  }

  add(event) {
    event.preventDefault()
    
    // Get template content
    const content = this.templateTarget.innerHTML
    
    // Generate unique ID based on timestamp
    const timestamp = new Date().getTime()
    
    // Replace NEW_RECORD placeholder with unique timestamp
    const newContent = content.replace(/NEW_RECORD/g, timestamp)
    
    // Create a temporary container to hold the new HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = newContent
    const newField = tempDiv.firstElementChild
    
    // Add the new field to container with animation
    newField.style.opacity = '0'
    this.containerTarget.appendChild(newField)
    
    // Trigger animation
    requestAnimationFrame(() => {
      newField.style.transition = 'opacity 0.3s ease-in-out'
      newField.style.opacity = '1'
    })
  }

  remove(event) {
    event.preventDefault()
    
    // Rows mark themselves either way in this app: data-nested-form-item
    // (the contacts components) or data-nested-form-target="item".
    const field = event.target.closest('[data-nested-form-item], [data-nested-form-target~="item"]')
    if (!field) return
    
    // Check if this is a persisted record
    const destroyInput = field.querySelector('input[name*="_destroy"]')
    
    if (destroyInput) {
      // For persisted records, mark for destruction
      destroyInput.value = '1'
      
      // Hide the field with animation
      field.style.transition = 'opacity 0.3s ease-in-out, max-height 0.3s ease-in-out'
      field.style.opacity = '0'
      field.style.maxHeight = '0'
      field.style.overflow = 'hidden'
      field.style.marginBottom = '0'
      field.style.paddingTop = '0'
      field.style.paddingBottom = '0'
      
      // After animation, hide completely but keep in DOM
      setTimeout(() => {
        field.style.display = 'none'
      }, 300)
    } else {
      // For new records, remove from DOM with animation
      field.style.transition = 'opacity 0.3s ease-in-out, max-height 0.3s ease-in-out'
      field.style.opacity = '0'
      field.style.maxHeight = '0'
      field.style.overflow = 'hidden'
      field.style.marginBottom = '0'
      field.style.paddingTop = '0'
      field.style.paddingBottom = '0'
      
      setTimeout(() => {
        field.remove()
      }, 300)
    }
  }
}

